import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const EventCardSkeleton = React.memo(() => {
  return (
    <div className="card">
      <div style={{ height: "370px" }}>
        <Skeleton height="100%" />
      </div>
      <div className="card-body">
        <Skeleton height={20} width="80%" className="mb-2 mt-2" />
        <Skeleton height={16} width="60%" className="mb-1" />
        <Skeleton height={16} width="40%" className="mb-2" />
        <Skeleton height={16} width="50%" className="mb-2" />
        <div className="d-flex gap-2 mb-2">
          <Skeleton height={24} width={60} />
          <Skeleton height={24} width={80} />
          <Skeleton height={24} width={70} />
        </div>
      </div>
      <div className="card-footer bg-transparent border-1">
        <div className="card-footer-content" style={{ margin: "0px" }}>
          <Skeleton height={32} width={200} />
        </div>
      </div>
    </div>
  );
});

export default EventCardSkeleton;
